import useTLO from "./useTLO"

export default function useDeal(id) {
  return useTLO("deal", id)
}
